/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmUserEmailRequest
 */
export interface ConfirmUserEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmUserEmailRequest
     */
    confirmationToken: string;
}

/**
 * Check if a given object implements the ConfirmUserEmailRequest interface.
 */
export function instanceOfConfirmUserEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confirmationToken" in value;

    return isInstance;
}

export function ConfirmUserEmailRequestFromJSON(json: any): ConfirmUserEmailRequest {
    return ConfirmUserEmailRequestFromJSONTyped(json, false);
}

export function ConfirmUserEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmUserEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confirmationToken': json['confirmation_token'],
    };
}

export function ConfirmUserEmailRequestToJSON(value?: ConfirmUserEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confirmation_token': value.confirmationToken,
    };
}

